import { render } from "./TheLocale.vue?vue&type=template&id=4f685894"
import script from "./TheLocale.vue?vue&type=script&lang=js"
export * from "./TheLocale.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__